<div>
    <div class="d-flex 100-vh lodertriple" *ngIf="_shareService.loading!=0 " >
        <div class="triple-spinner"></div>
    </div>
    <!-- aman singhal -->
    <router-outlet></router-outlet>
    <!-- gs -->
    <app-sagtoast></app-sagtoast>
    <app-themes *ngIf="common.themeActiveStatus"></app-themes>
</div>


